/* ==========================================================================
 * bs-product.js - gedrag van de Birdstopper-productpagina (sections/bs-product.liquid)
 * --------------------------------------------------------------------------
 * - variant kiezen met de knoppen Diameter en Lengte, de tabel Alle maten,
 *   de fotominiaturen of het keuzemenu (andere producten)
 * - bij wisselen bijwerken: prijs, prijs per meter, beschikbaarheid, foto,
 *   palletblok (event bs:variant), gemarkeerde tabelrij, artikelnummer, URL
 * - toevoegen aan de winkelwagen via window.BBWinkel.pakketToevoegen, zodat de
 *   teller in de kop meeloopt (BBWinkel.meldWijziging)
 * - op de telefoon: inklapbare secties, fotostrook met stippen, vaste koopbalk
 *
 * Prijzen: alle bedragen gaan door window.BSBtw.prijsHtml. Hier wordt niets met
 * geld verrekend behalve de prijs per meter voor de weergave (prijs / meters,
 * afgerond op hele centen, net als in de Liquid).
 * ========================================================================== */
(function () {
  'use strict';

  var TEKST = {
    toevoegen: 'In winkelwagen',
    bezig: 'Bezig met toevoegen',
    uitverkocht: 'Uitverkocht',
    voorraad: {
      op: 'Op voorraad',
      na: 'Tijdelijk niet op voorraad, wel te bestellen',
      uit: 'Uitverkocht'
    },
    gelukt: function (n, label) { return 'Toegevoegd aan je winkelwagen: ' + n + 'x ' + label + '.'; },
    bekijk: 'Bekijk je winkelwagen',
    mislukt: 'Dit is niet toegevoegd aan je winkelwagen.',
    mislukt_verder: 'Probeer het opnieuw of neem contact met ons op.',
    geen_verbinding: 'Er ging iets mis met de verbinding.'
  };

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function bedrag(c) {
    if (window.BSBtw && window.BSBtw.bedrag) { return window.BSBtw.bedrag(c); }
    return '€ ' + (Math.round(c) / 100).toFixed(2).replace('.', ',');
  }
  function exclCenten(c) {
    if (window.BSBtw && window.BSBtw.exclCenten) { return window.BSBtw.exclCenten(c); }
    return Math.round(Number(c) * 100 / 121);
  }
  function prijsHtml(c, opties) {
    if (window.BSBtw && window.BSBtw.prijsHtml) { return window.BSBtw.prijsHtml(c, opties); }
    return '<span class="bs-prijs">' + bedrag(c) + '</span>';
  }
  function perMeter(v) {
    return v.meters > 0 ? Math.round(v.prijs / v.meters) : 0;
  }
  function meterGetal(m) {
    return String(Math.round(m * 10) / 10).replace('.', ',');
  }

  function alles(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  function init(root) {
    if (!root || root.__bsPP) { return; }
    var bron = root.querySelector('script[data-pp-data]');
    if (!bron) { return; }
    var data;
    try { data = JSON.parse(bron.textContent); } catch (e) { return; }
    root.__bsPP = true;

    var varianten = data.varianten || [];
    var perId = {};
    varianten.forEach(function (v) { perId[String(v.id)] = v; });
    var huidig = perId[String(data.gekozen)] || varianten[0];
    if (!huidig) { return; }

    var el = function (naam) { return root.querySelector('[data-pp="' + naam + '"]'); };
    var buhne = el('buhne');
    var form = el('form');
    var aantalVeld = el('aantal');
    var hoofdKnop = el('toevoegen');
    var melding = el('melding');
    var toast = el('toast');
    var bezig = false;

    /* ---------------- variant kiezen ---------------- */

    function lengtesHtml(d) {
      var lijst = varianten.filter(function (v) { return v.diameter === d; })
        .sort(function (a, b) { return a.meters - b.meters; });
      return lijst.map(function (v) {
        var aan = v.id === huidig.id;
        var rol = v.rollen === 1 ? '1 rol' : v.rollen + ' rollen';
        if (v.voorraad === 'uit') { rol += ', uitverkocht'; }
        return '<button type="button" class="bs-pp-optie' + (aan ? ' is-aan' : '') + (v.voorraad === 'uit' ? ' is-uit' : '')
          + '" data-variant="' + v.id + '" aria-pressed="' + (aan ? 'true' : 'false') + '">'
          + '<b>' + meterGetal(v.meters) + ' meter</b>'
          + '<small class="bs-pp-alleen-desktop">' + esc(rol) + '</small>'
          + '<small class="bs-pp-alleen-mobiel">' + prijsHtml(v.prijs, { maat: 'klein' }) + '</small>'
          + '</button>';
      }).join('');
    }

    function zetLengtes() {
      var doos = el('lengtes');
      if (!doos) { return; }
      var zelfde = doos.getAttribute('data-diameter') === String(huidig.diameter);
      if (zelfde) {
        alles(doos, '[data-variant]').forEach(function (k) {
          var aan = k.getAttribute('data-variant') === String(huidig.id);
          k.classList.toggle('is-aan', aan);
          k.setAttribute('aria-pressed', aan ? 'true' : 'false');
        });
      } else {
        doos.innerHTML = lengtesHtml(huidig.diameter);
        doos.setAttribute('data-diameter', String(huidig.diameter));
      }
      doos.setAttribute('data-aantal', String(doos.children.length));
    }

    function zetFoto(scrollen) {
      var fotos = alles(root, '[data-variant-foto]');
      var heeft = fotos.some(function (f) { return f.getAttribute('data-variant-foto') === String(huidig.id); });
      if (heeft) {
        fotos.forEach(function (f) { f.hidden = f.getAttribute('data-variant-foto') !== String(huidig.id); });
        var img = root.querySelector('[data-variant-foto="' + huidig.id + '"] img');
        if (img && img.loading === 'lazy') { img.loading = 'eager'; }
      }
      alles(root, '[data-mini-variant]').forEach(function (m) {
        if (huidig.diameter) { m.hidden = m.getAttribute('data-diameter') !== String(huidig.diameter); }
      });
      var weggevallen = zetSkuFotos();
      if (scrollen || weggevallen) { naarDia(0); } else { zetDiaAan(huidigeDia()); }
    }

    function zetVoorraad() {
      alles(root, '[data-pp="voorraad"]').forEach(function (v) {
        v.setAttribute('data-stand', huidig.voorraad);
        var t = v.querySelector('[data-pp="voorraad-tekst"]');
        if (t) { t.textContent = TEKST.voorraad[huidig.voorraad] || ''; }
      });
      var uit = huidig.voorraad === 'uit';
      if (!bezig) {
        if (hoofdKnop) {
          hoofdKnop.disabled = uit;
          var kt = el('knoptekst');
          if (kt) { kt.textContent = uit ? TEKST.uitverkocht : TEKST.toevoegen; }
        }
        alles(root, '[data-pp="toevoegen-extra"]').forEach(function (k) {
          k.disabled = uit;
          k.textContent = uit ? TEKST.uitverkocht : TEKST.toevoegen;
        });
      }
    }

    function zetPrijs() {
      var p = el('prijs');
      if (p) { p.innerHTML = prijsHtml(huidig.prijs, { maat: 'groot', achtervoegsel: true }); }
      var a = el('anders');
      if (a) {
        a.innerHTML = '<span class="bs-incl">' + bedrag(exclCenten(huidig.prijs)) + ' excl. btw</span>'
          + '<span class="bs-excl">' + bedrag(huidig.prijs) + ' incl. btw</span>';
      }
      var pm = el('permeter');
      if (pm) {
        var c = perMeter(huidig);
        pm.innerHTML = c > 0 ? prijsHtml(c, { maat: 'klein' }) + ' per meter' : '';
      }
      var pk = el('prijs-klein');
      if (pk) { pk.innerHTML = prijsHtml(huidig.prijs, { maat: 'normaal' }); }
      var pv = el('prijs-vast');
      if (pv) { pv.innerHTML = prijsHtml(huidig.prijs, { maat: 'normaal' }); }
      alles(root, '[data-pp="label"]').forEach(function (l) { l.textContent = huidig.label; });
      alles(root, '[data-pp="sku"]').forEach(function (s) { s.textContent = huidig.sku || ''; });
    }

    function zetTabel() {
      alles(root, '[data-rij-variant]').forEach(function (rij) {
        var aan = rij.getAttribute('data-rij-variant') === String(huidig.id);
        rij.classList.toggle('is-gekozen', aan);
        var pil = rij.querySelector('.bs-pp-pil-gekozen');
        var link = rij.querySelector('[data-kies-variant]');
        if (pil) { pil.hidden = !aan; }
        if (link) { link.hidden = aan; }
      });
    }

    function zetDiameters() {
      alles(root, '[data-pp="diameters"] [data-diameter]').forEach(function (k) {
        var aan = k.getAttribute('data-diameter') === String(huidig.diameter);
        k.classList.toggle('is-aan', aan);
        k.setAttribute('aria-pressed', aan ? 'true' : 'false');
      });
      var sel = el('select');
      if (sel) { sel.value = String(huidig.id); }
    }

    function zetUrl() {
      if (!window.history || !window.history.replaceState) { return; }
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', String(huidig.id));
        window.history.replaceState(window.history.state, '', url.toString());
      } catch (e) { /* oude browser: dan blijft de URL staan */ }
    }

    function kies(v, opties) {
      if (!v) { return; }
      opties = opties || {};
      var anders = v.id !== huidig.id;
      huidig = v;
      var idVeld = el('variant-id');
      if (idVeld) { idVeld.value = String(v.id); }
      zetDiameters();
      zetLengtes();
      zetPrijs();
      zetVoorraad();
      zetTabel();
      zetFoto(opties.fotoNaarVoren !== false);
      if (anders) {
        document.dispatchEvent(new CustomEvent('bs:variant', { detail: { id: v.id } }));
        zetUrl();
        verbergMelding();
      }
    }

    function kiesDiameter(d) {
      if (d === huidig.diameter) { return; }
      var kandidaten = varianten.filter(function (v) { return v.diameter === d; });
      if (!kandidaten.length) { return; }
      /* dichtstbijzijnde lengte; bij gelijke afstand de langere; liefst niet uitverkocht */
      kandidaten.sort(function (a, b) {
        var da = Math.abs(a.meters - huidig.meters);
        var db = Math.abs(b.meters - huidig.meters);
        if (da !== db) { return da - db; }
        return b.meters - a.meters;
      });
      var beste = kandidaten[0];
      if (beste.voorraad === 'uit') {
        var beschikbaar = kandidaten.filter(function (v) { return v.voorraad !== 'uit'; })[0];
        if (beschikbaar && Math.abs(beschikbaar.meters - huidig.meters) === Math.abs(beste.meters - huidig.meters)) {
          beste = beschikbaar;
        }
      }
      kies(beste);
    }

    /* ---------------- galerij ---------------- */

    /* Alleen de zichtbare dia's tellen mee. Een galerijfoto met "alleen tonen bij artikelnummer" staat bij
       andere maten op hidden; zou je die meetellen, dan springen miniaturen en stippen naar de verkeerde foto.
       Daarom rekenen we altijd met het data-dia-nummer van de dia en niet met zijn plek in de rij. */
    function dias() { return buhne ? alles(buhne, '.bs-pp-dia').filter(function (d) { return !d.hidden; }) : []; }

    function huidigeDia() {
      if (!buhne || !buhne.clientWidth) { return 0; }
      var zicht = dias();
      var d = zicht[Math.round(buhne.scrollLeft / buhne.clientWidth)];
      return d ? (parseInt(d.getAttribute('data-dia'), 10) || 0) : 0;
    }

    /* Galerijfoto's die een vaste maat noemen (bijvoorbeeld "8 meter, 15 cm") alleen bij die maat tonen. */
    function zetSkuFotos() {
      var sku = String(huidig.sku || '');
      var verborgenAan = false;
      var nu = huidigeDia();
      alles(root, '[data-alleen-sku]').forEach(function (e) {
        var weg = e.getAttribute('data-alleen-sku') !== sku;
        e.hidden = weg;
        if (weg && e.classList.contains('bs-pp-dia') && e.getAttribute('data-dia') === String(nu)) { verborgenAan = true; }
      });
      return verborgenAan;
    }

    function zetDiaAan(i) {
      alles(root, '[data-stip]').forEach(function (s) {
        s.classList.toggle('is-aan', s.getAttribute('data-stip') === String(i));
      });
      alles(root, '.bs-pp-mini-knop').forEach(function (m) {
        var aan = i === 0
          ? m.getAttribute('data-mini-variant') === String(huidig.id)
          : m.getAttribute('data-mini-dia') === String(i);
        m.classList.toggle('is-aan', aan);
      });
    }

    function naarDia(i) {
      var lijst = dias();
      var doel = buhne ? buhne.querySelector('.bs-pp-dia[data-dia="' + i + '"]') : null;
      if (doel && doel.hidden) { doel = null; i = 0; }
      if (!doel) { doel = lijst[0]; i = 0; }
      if (buhne && doel) {
        var links = doel.offsetLeft - lijst[0].offsetLeft;
        if (typeof buhne.scrollTo === 'function') {
          buhne.scrollTo({ left: links, behavior: 'smooth' });
        } else {
          buhne.scrollLeft = links;
        }
      }
      zetDiaAan(i);
    }

    if (buhne) {
      var wacht = null;
      buhne.addEventListener('scroll', function () {
        if (wacht) { window.cancelAnimationFrame(wacht); }
        wacht = window.requestAnimationFrame(function () { zetDiaAan(huidigeDia()); });
      }, { passive: true });
    }

    /* ---------------- aantal ---------------- */

    function aantal() {
      var n = parseInt(aantalVeld ? aantalVeld.value : '1', 10);
      if (!isFinite(n) || n < 1) { n = 1; }
      if (n > 9999) { n = 9999; }
      return n;
    }
    function zetAantal(n) {
      if (aantalVeld) { aantalVeld.value = String(Math.max(1, Math.min(9999, n))); }
    }
    if (aantalVeld) {
      aantalVeld.addEventListener('change', function () { zetAantal(aantal()); });
      aantalVeld.addEventListener('input', function () {
        var schoon = aantalVeld.value.replace(/[^0-9]/g, '');
        if (schoon !== aantalVeld.value) { aantalVeld.value = schoon; }
      });
    }

    /* ---------------- winkelwagen ---------------- */

    function verbergMelding() {
      if (melding) { melding.hidden = true; melding.innerHTML = ''; }
      if (toast) { toast.hidden = true; toast.innerHTML = ''; }
    }

    var toastTimer = null;
    function toon(goed, html, alsToast) {
      var doel = alsToast ? toast : melding;
      var ander = alsToast ? melding : toast;
      if (ander) { ander.hidden = true; ander.innerHTML = ''; }
      if (!doel) { return; }
      doel.className = doel.className.replace(/\bis-(goed|fout)\b/g, '').trim() + (goed ? ' is-goed' : ' is-fout');
      doel.innerHTML = html;
      doel.hidden = false;
      if (alsToast) {
        if (toastTimer) { window.clearTimeout(toastTimer); }
        toastTimer = window.setTimeout(function () { toast.hidden = true; }, 7000);
      }
    }

    function knoppenBezig(aan) {
      var alle = [hoofdKnop].concat(alles(root, '[data-pp="toevoegen-extra"]')).filter(Boolean);
      alle.forEach(function (k) {
        if (aan) {
          k.setAttribute('aria-busy', 'true');
          k.disabled = true;
        } else {
          k.removeAttribute('aria-busy');
        }
      });
      var kt = el('knoptekst');
      if (aan && kt) { kt.textContent = TEKST.bezig; }
      if (!aan) { zetVoorraad(); }
    }

    function toevoegen(alsToast) {
      if (bezig || huidig.voorraad === 'uit') { return; }
      if (!window.BBWinkel || typeof window.BBWinkel.pakketToevoegen !== 'function') {
        /* zonder de winkelwagenlaag: gewoon het Shopify-formulier versturen */
        if (form) { form.submit(); }
        return;
      }
      var n = aantal();
      var v = huidig;
      bezig = true;
      knoppenBezig(true);
      verbergMelding();

      window.BBWinkel.pakketToevoegen(
        { regels: [{ product: { id: v.id, variant_id: v.id }, aantal: n }] },
        { secties: 'cart-icon-bubble' }
      ).then(function (uit) {
        try { window.BBWinkel.meldWijziging(uit.antwoord); } catch (e) { /* teller bijwerken is geen voorwaarde */ }
        var link = ' <a href="' + esc(data.winkelwagenUrl || '/cart') + '">' + TEKST.bekijk + '</a>';
        toon(true, esc(TEKST.gelukt(n, (data.product ? data.product + ' ' : '') + v.label)) + link, alsToast);
      }).catch(function (fout) {
        var uitleg = fout && fout.uitlegVanShopify ? String(fout.uitlegVanShopify) : '';
        var tekst = TEKST.mislukt + ' ' + (uitleg ? uitleg : (fout && fout.allesOfNiets ? TEKST.mislukt_verder : TEKST.geen_verbinding + ' ' + TEKST.mislukt_verder));
        toon(false, esc(tekst), alsToast);
      }).then(function () {
        bezig = false;
        knoppenBezig(false);
      });
    }

    /* ---------------- klikken ---------------- */

    root.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) { return; }

      var k = t.closest('[data-pp="diameters"] [data-diameter]');
      if (k) { e.preventDefault(); kiesDiameter(parseInt(k.getAttribute('data-diameter'), 10)); return; }

      k = t.closest('[data-pp="lengtes"] [data-variant]');
      if (k) { e.preventDefault(); kies(perId[k.getAttribute('data-variant')]); return; }

      k = t.closest('[data-mini-variant]');
      if (k) {
        e.preventDefault();
        var mv = perId[k.getAttribute('data-mini-variant')];
        if (mv && mv.id !== huidig.id) { kies(mv); } else { naarDia(0); }
        return;
      }

      k = t.closest('[data-mini-dia]');
      if (k) { e.preventDefault(); naarDia(parseInt(k.getAttribute('data-mini-dia'), 10) || 0); return; }

      k = t.closest('[data-pp="min"]');
      if (k) { e.preventDefault(); zetAantal(aantal() - 1); return; }
      k = t.closest('[data-pp="plus"]');
      if (k) { e.preventDefault(); zetAantal(aantal() + 1); return; }

      k = t.closest('[data-pp="toevoegen-extra"]');
      if (k) { e.preventDefault(); toevoegen(true); return; }

      k = t.closest('[data-rij-variant]');
      if (k && !t.closest('.bs-pp-pil-gekozen')) {
        var rv = perId[k.getAttribute('data-rij-variant')];
        if (rv) {
          e.preventDefault();
          kies(rv);
          var koop = root.querySelector('.bs-pp-koop');
          if (koop && koop.getBoundingClientRect().bottom < 0 && koop.scrollIntoView) {
            koop.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }
        return;
      }

      k = t.closest('.bs-pp-klap');
      if (k) {
        e.preventDefault();
        var sectie = k.closest('.bs-pp-sectie');
        if (sectie) {
          var open = !sectie.classList.contains('is-open');
          sectie.classList.toggle('is-open', open);
          k.setAttribute('aria-expanded', open ? 'true' : 'false');
        }
        return;
      }

      k = t.closest('[data-pp-naar], .bs-pp-nav a[href^="#"]');
      if (k) {
        var id = (k.getAttribute('href') || '').replace(/^#/, '');
        var doel = id ? document.getElementById(id) : null;
        if (doel) {
          e.preventDefault();
          openSectie(doel);
          doel.scrollIntoView({ behavior: 'smooth', block: 'start' });
          if (window.history && window.history.replaceState) {
            try { window.history.replaceState(window.history.state, '', '#' + id); } catch (e2) { /* niet erg */ }
          }
        }
      }
    });

    function openSectie(sectie) {
      if (!sectie || !sectie.classList.contains('bs-pp-sectie')) { return; }
      sectie.classList.add('is-open');
      var knop = sectie.querySelector('.bs-pp-klap');
      if (knop) { knop.setAttribute('aria-expanded', 'true'); }
    }

    var sel = el('select');
    if (sel) {
      sel.addEventListener('change', function () { kies(perId[sel.value]); });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        toevoegen(false);
      });
    }

    /* ---------------- sectienavigatie en vaste balk ---------------- */

    if ('IntersectionObserver' in window) {
      var navLinks = alles(root, '.bs-pp-nav a[data-nav]');
      if (navLinks.length) {
        var zichtbaar = {};
        var navObs = new IntersectionObserver(function (items) {
          items.forEach(function (it) { zichtbaar[it.target.getAttribute('data-sectie')] = it.isIntersecting; });
          var eerste = null;
          alles(root, '.bs-pp-sectie[data-sectie]').some(function (s) {
            if (zichtbaar[s.getAttribute('data-sectie')]) { eerste = s.getAttribute('data-sectie'); return true; }
            return false;
          });
          if (eerste) {
            navLinks.forEach(function (a) { a.classList.toggle('is-aan', a.getAttribute('data-nav') === eerste); });
          }
        }, { rootMargin: '-35% 0px -55% 0px' });
        alles(root, '.bs-pp-sectie[data-sectie]').forEach(function (s) { navObs.observe(s); });
      }

      var vast = el('vast');
      var koopt = root.querySelector('.bs-pp-koopt');
      if (vast && koopt) {
        var vastObs = new IntersectionObserver(function (items) {
          items.forEach(function (it) {
            var toon = !it.isIntersecting && it.boundingClientRect.top < 0;
            vast.classList.toggle('is-zichtbaar', toon);
            vast.setAttribute('aria-hidden', toon ? 'false' : 'true');
            var knop = vast.querySelector('button');
            if (knop) { knop.tabIndex = toon ? 0 : -1; }
          });
        });
        vastObs.observe(koopt);
      }
    }

    /* openen via een #anker in de URL (bijvoorbeeld een link naar #bs-pp-faq-...) */
    if (window.location.hash) {
      try { openSectie(document.getElementById(window.location.hash.slice(1))); } catch (e) { /* ongeldige hash */ }
    }

    /* beginstand gelijkzetten (zelfde variant, dus geen URL-wijziging) */
    var lengtesDoos = el('lengtes');
    if (lengtesDoos) {
      lengtesDoos.setAttribute('data-diameter', String(huidig.diameter));
      lengtesDoos.setAttribute('data-aantal', String(lengtesDoos.children.length));
    }
    zetDiaAan(0);
  }

  function initAlles() {
    alles(document, '[data-bs-product]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAlles);
  } else {
    initAlles();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var t = e && e.target;
    if (t && t.querySelector) {
      var r = t.querySelector('[data-bs-product]');
      if (r) { init(r); }
    }
  });

})();
